import {ChatboxPosition, Crisp} from "crisp-sdk-web";
import EnvService from '../env';

export interface SetUserData {
    email?: string;
    nickname?: string;
    phone?: string;
    avatar?: string;
    company?: string;
    partnerId?: string;
}


/**
 * The Crisp Service.
 *
 * This service is used to interact with the Crisp SDK.
 */
class CrispService {

    /**
     * The Crisp SDK Singleton instance.
     * @private
     */
    private static crisp: typeof Crisp = Crisp;

    /**
     * Whether the chat box is opened or not.
     */
    static get isChatOpened() {
        return this.crisp.chat.isChatOpened()
    }

    /**
     * Whether the chat box is visible or not.
     */
    static get isChatVisible() {
        return this.crisp.chat.isVisible()
    }


    /**
     * Register the Crisp SDK.
     */
    static register(): void {
        this.crisp.configure(EnvService.crispWebsiteId);
        this.crisp.setPosition(ChatboxPosition.Right);
        this.hideChatBox();
    }

    /**
     * Hide the Crisp chat box.
     */
    static hideChatBox(): void {
        this.crisp.chat.hide();
    }

    /**
     * Show the Crisp chat box.
     */
    static showChatBox(): void {
        this.crisp.chat.show();
    }

    /**
     * open the Crisp chat box.
     */
    static openChatBox(): void {
        this.crisp.chat.open();
    }

    /**
     * close the Crisp chat box.
     */
    static closeChatBox(): void {
        this.crisp.chat.close();
    }

    /**
     * Attaches a callback for when the chat box is Opened
     * @param callback
     */
    static onChatBoxOpened(callback: () => void): void {
        this.crisp.chat.onChatOpened(callback);
    }

    /**
     * Attaches a callback for when the chat box is Closed
     * @param callback
     */
    static onChatBoxClosed(callback: () => void): void {
        this.crisp.chat.onChatClosed(callback);
    }

    /**
     * Load the Crisp chat box.
     */
    static load(): void {
        return this.crisp.load();
    }

    /**
     * Show the Crisp chat box user information.
     * @param data
     */
    static setUser(data: SetUserData) {
        if (data.nickname) {
            this.crisp.user.setNickname(data.nickname);
            this.crisp.session.setData({
                nickname: data.nickname,
            })
        }
        if (data.email) {
            this.crisp.user.setEmail(data.email);
            this.crisp.session.setData({
                email: data.email,
            });
        }
        if (data.phone) {
            this.crisp.user.setPhone(data.phone);
            this.crisp.session.setData({
                phone: data.phone,
            });
        }
        if (data.avatar) {
            this.crisp.user.setAvatar(data.avatar);
            this.crisp.session.setData({
                avatar: data.avatar,
            });
        }
        if (data.company) {
            this.crisp.user.setCompany(data.company, {});
            this.crisp.session.setData({
                company: data.company,
            });
        }
        if (data.partnerId) {
            this.crisp.session.setData({
                partnerId: data.partnerId,
            })
        }
        if (data.partnerId) {
            this.crisp.session.setData({
                partnerId: data.partnerId,
            })
        }
        this.crisp.session.setData({
            platform: EnvService.websiteName,
            platformURL: window.location.href,
        })
    }
}

export default CrispService;
